module.exports = __webpack_public_path__ + "img/top-right-decoration.8bc8f138.svg";